import React from 'react';
import MeasurementsContainer from './MeasurementsIndexContainer';
import {
  useTimestamp,
  CurrentMeasurementsConnectorApollo,
} from '@front-activerse/common-components';

interface IMeasurementPageProps {
  availableMeasurements: string[][];
  paths: {
    PATH_MEASUREMENT: string;
    PATH_MEASUREMENT_ADD: string;
    PATH_MEASUREMENT_EDIT: string;
  };
}

const MeasurementsPage: React.FC<IMeasurementPageProps> = ({ availableMeasurements, paths }) => {
  const { timestamp1 } = useTimestamp();
  return (
    <CurrentMeasurementsConnectorApollo>
      {(currentMeasurementData: any) => (
        <MeasurementsContainer
          {...currentMeasurementData}
          loading={currentMeasurementData.loading}
          key={timestamp1}
          availableMeasurements={availableMeasurements}
          paths={paths}
        />
      )}
    </CurrentMeasurementsConnectorApollo>
  );
};

export default MeasurementsPage;
